/* eslint-disable */
import saveStoreDraft from "../../utils/saveStoreDraft";
import { useTranslation as useUiTranslation } from "react-i18next";
import React, { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import QuillEditor from "./TextEditor";
import ThanksPageBuilder from "./ThanksPageBuilder";
import { doc } from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelector } from "react-redux";
import apicache from "../../components/clearCach/clear";

const Model3 = ({ show, setShow, data, setData }) => {
  const { t: uiT } = useUiTranslation();
  const products = useSelector((state) => state.ProductsReducer);
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const isManualChange = useRef(false);
  const isInitialized = useRef(false); // ✅ جديد: نتراكيو واش initialisation صار

  const MySwal = withReactContent(Swal);

  // Default settings for theme 2
  const defaultThanksSettings = {
    active: true, // true = Builder, false = QuillEditor
    theme: 2,
    mainTitle: "شُكرا جزيلا على ثِقتكم",
    successBadge: "تم استلام الطلب بنجاح!",
    mainText: "نحن نقدر تفضيلك لمنتجاتنا ونحن سعداء لإعلامك أن",
    highlightText: "طلبك قد تم استلامه بنجاح",
    afterHighlight: "، الآن هناك خطوة واحدة أخيرة لضمان تأكيد طلبك بشكل كامل.",
    noteTitle: "ملاحظة مهمة:",
    noteText: "يرجى الاطلاع على الإشعار في الأسفل لتأكيد طلبك (",
    noteHighlight: "لن يتم إرسال الطلب بدون تأكيده",
    noteEnd: ")",
  };

  const [thanksSettings, setThanksSettings] = useState(defaultThanksSettings);
  const [isTheme2, setIsTheme2] = useState(false);
  const [currentEditor, setCurrentEditor] = useState("builder"); // 'builder' او 'quill'

  useEffect(() => {
    if (!show) {
      isInitialized.current = false;
      return;
    }

    if (isInitialized.current) {
      return;
    }

    setIsTheme2(store?.theme === 2);
    if (store?.theme === 2) {
      if (data?.thanksSettings) {
        setThanksSettings(data.thanksSettings);
        setCurrentEditor(data.thanksSettings.active ? "builder" : "quill");
      } else {
        setThanksSettings(defaultThanksSettings);
        setCurrentEditor("builder");
      }
    }

    isInitialized.current = true;
  }, [show]);

  const handleClose = () => {
    setShow({
      model1: false,
      model2: false,
      model3: false,
    });
    isManualChange.current = false;
    isInitialized.current = false; // ✅ نرستو الـ flag
  };

  const handleEditorChange = (editorType) => {
    isManualChange.current = true;
    setCurrentEditor(editorType);
    setThanksSettings({
      ...thanksSettings,
      active: editorType === "builder",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    apicache(account, products);

    const updatedData = {
      ...data,
      ...(isTheme2 && { thanksSettings }),
    };

    try {
      await saveStoreDraft(doc(db, "store", data.id), store, updatedData);
      isManualChange.current = false;
      Swal.fire({
        icon: "success",
        title: uiT("settings.success"),
        confirmButtonText: uiT("ship.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } catch (error) {
      Swal.fire({ icon: "error", title: uiT("ui.notSaved"), confirmButtonText: uiT("ship.ok") });
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} size="xl" className="w-100">
        <Modal.Header
          style={{
            background: "linear-gradient(135deg, #9b59bf 0%, #764ba2 100%)",
            border: "none",
            padding: "24px 32px",
            color: "white",
          }}
        >
          <Modal.Title
            style={{
              fontSize: "24px",
              fontWeight: "700",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              textShadow: "0 2px 4px rgba(0,0,0,0.2)",
            }}
          >
            <span style={{ fontSize: "28px" }}>🎉</span>
            {uiT("ui.thankYouPage")}
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body style={{ padding: "0" }}>
            {/* Theme 2: اختيار بين Builder و QuillEditor */}
            {isTheme2 && (
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #9b59bf 0%, #764ba2 100%)",
                  padding: "24px",
                  borderBottom: "1px solid rgba(255,255,255,0.1)",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                }}
              >
                <div style={{ maxWidth: "600px", margin: "0 auto" }}>
                  <h5
                    style={{
                      color: "white",
                      marginBottom: "20px",
                      fontSize: "18px",
                      fontWeight: "600",
                      textAlign: "center",
                      textShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    }}
                  >
                    {uiT("ui.chooseEditingMode")}
                  </h5>

                  <div
                    style={{
                      display: "flex",
                      gap: "16px",
                      justifyContent: "center",
                    }}
                  >
                    {/* Builder Option */}
                    <label
                      htmlFor="builder-option"
                      style={{
                        flex: "1",
                        maxWidth: "280px",
                        padding: "20px",
                        background:
                          currentEditor === "builder"
                            ? "white"
                            : "rgba(255,255,255,0.2)",
                        borderRadius: "16px",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        border:
                          currentEditor === "builder"
                            ? "3px solid #10b981"
                            : "3px solid transparent",
                        transform:
                          currentEditor === "builder"
                            ? "scale(1.05)"
                            : "scale(1)",
                        boxShadow:
                          currentEditor === "builder"
                            ? "0 8px 16px rgba(16, 185, 129, 0.3)"
                            : "0 4px 6px rgba(0,0,0,0.1)",
                      }}
                    >
                      <input
                        type="radio"
                        id="builder-option"
                        name="editor-type"
                        checked={currentEditor === "builder"}
                        onChange={() => handleEditorChange("builder")}
                        style={{ display: "none" }}
                      />
                      <div style={{ textAlign: "center" }}>
                        <div
                          style={{
                            fontSize: "48px",
                            marginBottom: "12px",
                            filter:
                              currentEditor === "builder"
                                ? "none"
                                : "grayscale(100%)",
                            opacity: currentEditor === "builder" ? 1 : 0.6,
                            transition: "all 0.3s ease",
                          }}
                        >
                          🎯
                        </div>
                        <div
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color:
                              currentEditor === "builder" ? "#1f2937" : "white",
                            marginBottom: "8px",
                            transition: "all 0.3s ease",
                          }}
                        >
                          {uiT("ui.readyThankYouPage")}{" "}
                        </div>
                        <div
                          style={{
                            fontSize: "13px",
                            color:
                              currentEditor === "builder"
                                ? "#6b7280"
                                : "rgba(255,255,255,0.8)",
                            lineHeight: "1.5",
                            transition: "all 0.3s ease",
                          }}
                        >
                          {uiT("ui.clickToEdit")}
                        </div>
                        {currentEditor === "builder" && (
                          <div
                            style={{
                              marginTop: "12px",
                              padding: "6px 12px",
                              background: "#10b981",
                              color: "white",
                              borderRadius: "20px",
                              fontSize: "12px",
                              fontWeight: "600",
                              display: "inline-block",
                            }}
                          >
                            {uiT("ui.activeCheck")}
                          </div>
                        )}
                      </div>
                    </label>

                    {/* QuillEditor Option */}
                    <label
                      htmlFor="quilleditor-option"
                      style={{
                        flex: "1",
                        maxWidth: "280px",
                        padding: "20px",
                        background:
                          currentEditor === "quill"
                            ? "white"
                            : "rgba(255,255,255,0.2)",
                        borderRadius: "16px",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        border:
                          currentEditor === "quill"
                            ? "3px solid #10b981"
                            : "3px solid transparent",
                        transform:
                          currentEditor === "quill"
                            ? "scale(1.05)"
                            : "scale(1)",
                        boxShadow:
                          currentEditor === "quill"
                            ? "0 8px 16px rgba(16, 185, 129, 0.3)"
                            : "0 4px 6px rgba(0,0,0,0.1)",
                      }}
                    >
                      <input
                        type="radio"
                        id="quilleditor-option"
                        name="editor-type"
                        checked={currentEditor === "quill"}
                        onChange={() => handleEditorChange("quill")}
                        style={{ display: "none" }}
                      />
                      <div style={{ textAlign: "center" }}>
                        <div
                          style={{
                            fontSize: "48px",
                            marginBottom: "12px",
                            filter:
                              currentEditor === "quill"
                                ? "none"
                                : "grayscale(100%)",
                            opacity: currentEditor === "quill" ? 1 : 0.6,
                            transition: "all 0.3s ease",
                          }}
                        >
                          📝
                        </div>
                        <div
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color:
                              currentEditor === "quill" ? "#1f2937" : "white",
                            marginBottom: "8px",
                            transition: "all 0.3s ease",
                          }}
                        >
                          {uiT("ui.plainTextEditor")}{" "}
                        </div>
                        <div
                          style={{
                            fontSize: "13px",
                            color:
                              currentEditor === "quill"
                                ? "#6b7280"
                                : "rgba(255,255,255,0.8)",
                            lineHeight: "1.5",
                            transition: "all 0.3s ease",
                          }}
                        >
                          {uiT("ui.formattingHelp")}
                        </div>
                        {currentEditor === "quill" && (
                          <div
                            style={{
                              marginTop: "12px",
                              padding: "6px 12px",
                              background: "#10b981",
                              color: "white",
                              borderRadius: "20px",
                              fontSize: "12px",
                              fontWeight: "600",
                              display: "inline-block",
                            }}
                          >
                            {uiT("ui.activeCheck")}
                          </div>
                        )}
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            )}

            {/* عرض المحتوى حسب الثيم والاختيار */}
            <div
              style={{
                padding:
                  isTheme2 && currentEditor === "builder" ? "24px" : "20px",
              }}
            >
              {isTheme2 ? (
                currentEditor === "builder" ? (
                  <ThanksPageBuilder
                    thanksSettings={thanksSettings}
                    setThanksSettings={setThanksSettings}
                    data={data}
                  />
                ) : (
                  <QuillEditor data={data} setData={setData} type={"thanks"} />
                )
              ) : (
                <QuillEditor data={data} setData={setData} type={"thanks"} />
              )}
            </div>
          </Modal.Body>
          <Modal.Footer
            style={{
              background: "#f8fafc",
              borderTop: "1px solid #e2e8f0",
              padding: "20px 32px",
              gap: "12px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="secondary"
              onClick={handleClose}
              style={{
                padding: "12px 32px",
                borderRadius: "12px",
                fontSize: "15px",
                fontWeight: "600",
                border: "none",
                background: "#64748b",
                transition: "all 0.3s ease",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
              onMouseOver={(e) => {
                e.target.style.background = "#475569";
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.15)";
              }}
              onMouseOut={(e) => {
                e.target.style.background = "#64748b";
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
              }}
            >
              {uiT("ui.cancelCross")}
            </Button>
            <Button
              variant="success"
              type="submit"
              style={{
                padding: "12px 32px",
                borderRadius: "12px",
                fontSize: "15px",
                fontWeight: "600",
                border: "none",
                background: "linear-gradient(135deg, #764ba2 0%, #9b59bf 100%)",
                transition: "all 0.3s ease",
                boxShadow: "0 4px 8px #764ba2",
              }}
              onMouseOver={(e) => {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 6px 12px #764ba2";
              }}
              onMouseOut={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 4px 8px #764ba2";
              }}
            >
              {uiT("ui.saveCheck")}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default Model3;
